import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { sound } from "@pixi/sound";
import { getSpineSymbol } from "../../config/getSymbol";
import { isSuperQuickBtnOnGlobal } from "../../config/GlobalVariableConfig";
import { AbstractDisplayComponent } from "../../core/displays/AbstractDisplayComponet";
import { DisplayComponent } from "../../core/displays/DisplayComponent";
import { wait } from "../../core/utils";
import { SequentialTask } from "../../core/utils/SequentialTask";
import { SoundConstants } from "../../gameClientEvents/SoundConstants";
import { IAdder, ICollect, IDouble, IRevealCoin, spinData } from "../../server/getServerResposesFun";
import { HoldReelComponent } from "../reels/HoldReelComponent";
import { WinMeterComponent } from "../winmeters/WinMeterComponent";

/** Prefix for god-feature Spine clips (`${prefix}in`, `${prefix}loop_blank`, etc.). Shared with ReelWin collect. */
export function getFeatureSymbolAnimPrefix(symbolId: number): string {
    let animPrefix = "lightning_strike_";
    switch (Number(symbolId)) {
        case 20:
            animPrefix = "lightning_strike_";
            break;
        case 21:
            animPrefix = "sticky_lightning_strike_";
            break;
        case 18:
            animPrefix = "inferno_double_";
            break;
        case 19:
            animPrefix = "sticky_inferno_double_";
            break;
        case 16:
            animPrefix = "ocean_collect_";
            break;
        case 17:
            animPrefix = "sticky_ocean_collect_";
            break;
    }
    return animPrefix;
}

export class WinSeqComponent extends AbstractDisplayComponent {
    private revealCoins: IRevealCoin[] = [];
    private currentRespinIndex: number = 0;
    private allFeatureArr: (ICollect | IDouble | IAdder)[] = [];

    public startWinSeqFeature(currentRespinIndex: number, callback?: () => void): Promise<any> {
        this.currentRespinIndex = currentRespinIndex;
        this.revealCoins = spinData.respins[currentRespinIndex].revealCoins;
        console.log(this.revealCoins, " ", spinData.respins[currentRespinIndex].revealCoins);
        const collects = spinData.respins[currentRespinIndex].collects;
        const adders = spinData.respins[currentRespinIndex].adders;
        const doubles = spinData.respins[currentRespinIndex].doubles;
        if (collects.length == 0 && adders.length == 0 && doubles.length == 0 && (!this.revealCoins || this.revealCoins.length === 0)) {
            //console.warn("No featureData found at index", RespinIndex.value);
            callback?.();
            return Promise.resolve();
        } else {
            spinData.respins[currentRespinIndex];
            console.log(spinData.respins[currentRespinIndex]);
        }

        let seq = new SequentialTask([
            () => this.revealSymbol(),
            () => wait(500),
            () => this.sortTheGodsOrder(currentRespinIndex),
            () => this.sortTheOrder(),
            () => this.callFeatureOneByone(),
            // () => this.collectFeature(currentRespinIndex),
            // () => this.adderFeature(currentRespinIndex),
            // () => this.doubleFeature(currentRespinIndex),
            () => {
                callback?.();
                return Promise.resolve();
            }
        ]);
        return seq.execute();
    }

    private async sortTheGodsOrder(respinIndex: number, callback?: () => void): Promise<any> {
        const collects = spinData.respins[respinIndex].collects;
        const adders = spinData.respins[respinIndex].adders;
        const doubles = spinData.respins[respinIndex].doubles;
        this.allFeatureArr = [...collects ?? [], ...adders ?? [], ...doubles ?? []];
        this.allFeatureArr.sort(
            (a, b) => a.reelNum - b.reelNum || a.posNum - b.posNum
        );
        callback?.();
        return Promise.resolve();
    }

    private async callFeatureOneByone(callback?: () => void): Promise<any> {
        const reels = DisplayComponent.get(HoldReelComponent).getInstance();

        for (let i = 0; i < this.allFeatureArr.length; i++) {

            const reelNum = this.allFeatureArr[i].reelNum;
            const posNum = this.allFeatureArr[i].posNum;

            const sym = reels.reelOverlaySymbols[reelNum][posNum].symbol;
            const symbolId = reels.reelOverlaySymbols[reelNum][posNum].symbolId;

            const animPrefix = getFeatureSymbolAnimPrefix(symbolId);
            const ts = this.godFeatureSymbolTimeScale(symbolId);

            // wait before feature starts so player can understand flow
            await wait(100);

            // play active feature animation only on its turn
            sym.state.timeScale = ts;
            sym.state.setAnimation(0, animPrefix + "loop", true);

            if (this.allFeatureArr[i].feature == "collect")
                await DisplayComponent.get(WinMeterComponent).getInstance().collectAllMultipliersInSerial(reelNum, posNum);

            else if (this.allFeatureArr[i].feature == "adder")
                await DisplayComponent.get(WinMeterComponent).getInstance().AddAllMultipliersInSerial(reelNum, posNum);

            else if (this.allFeatureArr[i].feature == "double")
                await DisplayComponent.get(WinMeterComponent).getInstance().doubleAllMultipliersInSerial(reelNum, posNum);

            // play out animation after feature ends
            await this.playAnimation(sym, animPrefix + "out", false, ts);

            // return back to blank loop
            sym.state.timeScale = ts;
            sym.state.setAnimation(
                0,
                animPrefix + "loop_blank",
                this.isStickySymbol(symbolId)
            );

            await wait(250);
        }

        callback?.();
        return Promise.resolve();
    }

    private async sortTheOrder(callback?: () => void): Promise<any> {
        await DisplayComponent.get(WinMeterComponent).getInstance().sortTheOrder();
        callback?.();
        return Promise.resolve();
    }

    public async collectFeature(respinIndex: number, callback?: () => void): Promise<any> {
        const collects = spinData.respins[respinIndex].collects;
        if (!collects || collects.length === 0) {
            callback?.();
            return Promise.resolve();
        }
        for (let i = 0; i < collects.length; i++) {
            //async () => {
            await DisplayComponent.get(WinMeterComponent).getInstance().collectAllMultipliersInSerial(collects[i].reelNum, collects[i].posNum);
            await wait(250);
            //}
        }
        callback?.();
        return Promise.resolve();
    }

    public async adderFeature(respinIndex: number, callback?: () => void): Promise<any> {
        const adders = spinData.respins[respinIndex].adders;
        if (!adders || adders.length === 0) {
            callback?.();
            return Promise.resolve();
        }
        for (let i = 0; i < adders.length; i++) {
            //async () => {
            await DisplayComponent.get(WinMeterComponent).getInstance().AddAllMultipliersInSerial(adders[i].reelNum, adders[i].posNum);
            await wait(250);
            //}
        }
        callback?.();
        return Promise.resolve();
    }

    public async doubleFeature(respinIndex: number, callback?: () => void): Promise<any> {
        const doubles = spinData.respins[respinIndex].doubles;
        if (!doubles || doubles.length === 0) {
            callback?.();
            return Promise.resolve();
        }
        for (let i = 0; i < doubles.length; i++) {
            //async () => {
            await DisplayComponent.get(WinMeterComponent).getInstance().doubleAllMultipliersInSerial(doubles[i].reelNum, doubles[i].posNum);
            await wait(250);
            //}
        }
        callback?.();
        return Promise.resolve();
    }

    private async revealSymbol(): Promise<void> {
        let taskArr: Promise<void>[] = [];
        this.revealCoins.sort(
            (a, b) => a.reelNum - b.reelNum || a.posNum - b.posNum
        );
        let revealWinPos = this.revealCoins;
        const reels = DisplayComponent.get(HoldReelComponent).getInstance();
        //this.markAllReelSymbols(reels, "0x555555");
        //this.markWinSymbols(reels, "0xffffff");
        //const colourTrail = DisplayComponent.get(TrailsComponent).getInstance().greenTrail;
        //trail?.skeleton.setToSetupPose();

        for (let i = 0; i < revealWinPos.length; i++) {

            if (i != 0)
                await wait(100);

            taskArr.push(new Promise<void>(async (resolve) => {

                const posNum = revealWinPos[i].posNum;
                const reelNum = revealWinPos[i].reelNum;

                const sym = reels.reelOverlaySymbols[reelNum][posNum].symbol;
                const revealedId = revealWinPos[i].id;
                const timeScale = this.godFeatureSymbolTimeScale(revealedId);

                sym.tint = "0xffffff";
                sym.state.timeScale = timeScale;
                if(revealedId == 13 || revealedId == 16 || revealedId == 17){
                    sound.play(SoundConstants.OCEAN, { volume: 1 });
                }
                if(revealedId == 14 || revealedId == 18 || revealedId == 19){
                    sound.play(SoundConstants.INFERNO_DOUBLE, { volume: 1 });
                }
                if(revealedId == 15 || revealedId == 20 || revealedId == 21){
                    sound.play(SoundConstants.OCEAN, { volume: 1 });
                }
                await this.playAnimation(sym, "win", false, timeScale);

                //this.getColourFeaturePot(this.getFeatureBallId(reels.allReelArray[reelNum], posNum))?.state.setAnimation(0, "collect", false);

                const newSym = getSpineSymbol(revealedId);

                this.swapSymbol(reelNum, posNum, true, newSym, revealedId);

                newSym.skeleton.setToSetupPose();
                newSym.state.timeScale = timeScale;

                newSym.skeleton.data.animations.forEach((anim) => { console.log(anim) });

                const animPrefix = getFeatureSymbolAnimPrefix(revealedId);

                reels.reelOverlaySymbols[reelNum][posNum].view.addChild(newSym)

                //await this.playAnimation(sym, "reveal", false);

                reels.reelOverlaySymbols[reelNum][posNum].view.removeChild(sym);

                sym.destroy();

                reels.reelOverlaySymbols[reelNum][posNum].symbol = newSym;

                await wait(10);

                this.currentRespinIndex;

                const winMeterComponent = DisplayComponent.get(WinMeterComponent).getInstance();

                winMeterComponent.setupMeter(
                    reelNum,
                    posNum,
                    spinData.respins[this.currentRespinIndex].coinValues[reelNum][posNum]
                );

                winMeterComponent.revealMultiplier(
                    reelNum + "_" + posNum,
                    spinData.respins[this.currentRespinIndex].coinValues[reelNum][posNum],
                    newSym
                );

                await wait(10);

                await this.playAnimation(
                    newSym,
                    animPrefix + "in",
                    false,
                    timeScale
                );

                newSym.state.setAnimation(
                    0,
                    animPrefix + "loop_blank",
                    true
                );

                resolve();

            }));
        }

        if (taskArr.length === 0) return Promise.resolve();

        await Promise.all(taskArr);
    }

    /** God feature symbols (getFeatureSymbolAnimPrefix table): play at 1× even when super quick is on. */
    private godFeatureSymbolTimeScale(symbolId: number | null | undefined): number {
        const id = Number(symbolId);
        if ([16, 17, 18, 19, 20, 21].includes(id)) {
            return 1;
        }
        return isSuperQuickBtnOnGlobal ? 2 : 1;
    }

    private isStickySymbol(symbolId: number): boolean {
        return [21, 19, 17].includes(Number(symbolId));
    }

    // private getFeatureBallId(reelObj: ReelObject, posNum: number): number {
    //     const symbol = reelObj.symbols[posNum];
    //     switch (symbol.id) {
    //         case 13:
    //             return 2;
    //         case 14:
    //             return 3;
    //         case 15:
    //             return 1;
    //         default:
    //             return 1;
    //     }
    // }


    // private getColourFeaturePot(potNum: number): Spine | null {
    //     switch (potNum) {
    //         case 1:
    //             return DisplayComponent.get(FeaturePotComponent).getInstance().greenFeatureIndicator;
    //         case 2:
    //             return DisplayComponent.get(FeaturePotComponent).getInstance().blueFeatureIndicator;
    //         case 3:
    //             return DisplayComponent.get(FeaturePotComponent).getInstance().redFeatureIndicator;
    //         default:
    //             return null;
    //     }
    // }

    private swapSymbol(reelNum: number, posNum: number, visibility: boolean = true, newSymbol: Spine, symbolId: number): void {
        const reels = DisplayComponent.get(HoldReelComponent).getInstance();
        const symbol = reels.reelOverlaySymbols[reelNum][posNum];
        visibility;
        if (symbol) {

            reels.reelOverlaySymbols[reelNum][posNum].symbolId = symbolId;
            reels.reelOverlaySymbols[reelNum][posNum].symbol = newSymbol;

            // // symbol.symbol.destroy();
            // const newSym = getSymbol(newSymbolId);
            // // symbol.view.addChildAt(newSym, 0);
            // symbol.id = newSymbolId;
            // symbol.symbol.texture = newSym;
            // // symbol.view.visible = visibility;
            // // symbol.view.tint = 0xffffff;
            // // symbol.view.alpha = 1;
            // symbol.symbolIndex = symbolId;

        }
    }

    private playAnimation(
        sym: Spine,
        animationName: string,
        loop: boolean = false,
        explicitTimeScale?: number
    ): Promise<void> {
        return new Promise((resolve) => {
            let resolved = false;
            const timeScale =
                explicitTimeScale !== undefined
                    ? explicitTimeScale
                    : isSuperQuickBtnOnGlobal
                        ? 2
                        : 1;
            const listener = {
                complete: () => {
                    if (resolved) return;
                    resolved = true;
                    sym.state.removeListener(listener);
                    resolve();
                }
            };
            sym.state.addListener(listener);
            sym.state.timeScale = timeScale;
            sym.state.setAnimation(0, animationName, loop);
        });
    }

    // //@ts-ignore
    // private showMeterHighlight() {
    //     // let triumpWin = this.transcoins.triumpWinData?.winAmount;
    //     // if (triumpWin > 0) {
    //     //     let jp = getJackpotEntryByValue(triumpWin);
    //     //     if (jp) {
    //     //         return new Promise<void>((resolve) => {
    //     //             DisplayComponent.get(MeterComponent).highlight(jp.index, resolve);
    //     //         });
    //     //     }
    //     // }

    //     return Promise.resolve();
    // }


    public getInstance(): any {
        return null;
    }
}